'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/FeaturedContentBlock.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FeaturedContentBlock = function (_BcReactComponent) {
  _inherits(FeaturedContentBlock, _BcReactComponent);

  function FeaturedContentBlock(props) {
    _classCallCheck(this, FeaturedContentBlock);

    var _this = _possibleConstructorReturn(this, (FeaturedContentBlock.__proto__ || Object.getPrototypeOf(FeaturedContentBlock)).call(this, props));

    _this.bindAll('renderContentLink');
    return _this;
  }

  _createClass(FeaturedContentBlock, [{
    key: 'renderEditLink',
    value: function renderEditLink(content) {
      if (this.props.editable) {
        var location = __CLIENT__ ? encodeURIComponent(window.location.href) : '';
        return _react2.default.createElement(
          'a',
          { href: '/featured_content/edit/' + content.get('id') + '?previous_location=' + location },
          _react2.default.createElement(_baseIcons.Pencil, null)
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'renderContentLink',
    value: function renderContentLink(content, index) {
      // TODO: Google Analytics - catagory: outbound, label: Featured Content
      var type = this.props.type;


      return _react2.default.createElement(
        'div',
        { className: 'content-link', key: type.toLowerCase() + '-link-' + index },
        _react2.default.createElement(
          'a',
          { href: content.get('url'), target: '_blank', rel: 'noopener noreferrer' },
          content.get('title'),
          ' ',
          _react2.default.createElement(_baseIcons.NewTab, { color: null })
        ),
        this.renderEditLink(content)
      );
    }
  }, {
    key: 'renderContentList',
    value: function renderContentList() {
      var _this2 = this;

      var _props = this.props,
          list = _props.list,
          twoColumns = _props.twoColumns,
          numContentToShow = _props.numContentToShow,
          type = _props.type;

      var chunkSize = Math.ceil(list.count() / (twoColumns ? 2.0 : 1));
      var visibleList = list.slice(0, numContentToShow);
      return _immutable2.default.Range(0, visibleList.count(), chunkSize).map(function (chunkStart, index) {
        return _react2.default.createElement(
          'div',
          { className: 'content-links', key: type.toLowerCase() + '-links-' + index },
          visibleList.slice(chunkStart, chunkStart + chunkSize).map(_this2.renderContentLink)
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-featured-content-block' },
        _react2.default.createElement(
          'div',
          { className: 'featured-content-card clearfix' },
          FeaturedContentBlock.renderContentTypeHeader(this.props.type),
          _react2.default.createElement(
            'div',
            { className: 'content-container' },
            this.renderContentList()
          )
        )
      );
    }
  }], [{
    key: 'renderContentTypeIcon',
    value: function renderContentTypeIcon(type) {
      var iconProps = {
        className: 'content-type-icon medium',
        color: '#0081b0'
      };

      switch (type) {
        case 'RESOURCE':
          return _react2.default.createElement(_baseIcons.Laptop, iconProps);
        case 'BLOG_POST':
          return _react2.default.createElement(_baseIcons.TextFile, iconProps);
        case 'EVENT':
          return _react2.default.createElement(_baseIcons.CalendarEmpty, iconProps);
        default:
          return null;
      }
    }
  }, {
    key: 'renderContentTypeHeader',
    value: function renderContentTypeHeader(type) {
      var typeSuffix = type === 'RESOURCE' ? 'online_resource' : type.toLowerCase();
      return _react2.default.createElement(
        'div',
        { className: 'content-header' },
        FeaturedContentBlock.renderContentTypeIcon(type),
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_featured_content_' + typeSuffix + 's' })
      );
    }
  }]);

  return FeaturedContentBlock;
}(_baseBcReactComponent2.default);

FeaturedContentBlock.propTypes = {
  type: _react.PropTypes.string.isRequired,
  list: _reactImmutableProptypes2.default.list.isRequired,
  twoColumns: _react.PropTypes.boolean,
  editable: _react.PropTypes.boolean,
  numContentToShow: _react.PropTypes.number // Number of links to show
};

FeaturedContentBlock.defaultProps = {
  numContentToShow: 5,
  editable: false
};

exports.default = FeaturedContentBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/featured-content-block/lib/components/FeaturedContentBlock.component.js
// module id = 1414
// module chunks = 1